import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M5.83333 17.5C5.375 17.5 4.98264 17.3368 4.65625 17.0104C4.32986 16.684 4.16667 16.2917 4.'
  + '16667 15.8333V5C3.93056 5 3.73264 4.92014 3.57292 4.76042C3.41319 4.60069 3.33333 4.40278 '
  + '3.33333 4.16667C3.33333 3.93056 3.41319 3.73264 3.57292 3.57292C3.73264 3.41319 3.93056 3.'
  + '33333 4.16667 3.33333H7.5C7.5 3.09722 7.57986 2.89931 7.73958 2.73958C7.8993 2.57986 8.097'
  + '22 2.5 8.33333 2.5H11.6667C11.9028 2.5 12.1007 2.57986 12.2604 2.73958C12.4201 2.89931 12.'
  + '5 3.09722 12.5 3.33333H15.8333C16.0694 3.33333 16.2674 3.41319 16.4271 3.57292C16.5868 3.7'
  + '3264 16.6667 3.93056 16.6667 4.16667C16.6667 4.40278 16.5868 4.60069 16.4271 4.76042C16.26'
  + '74 4.92014 16.0694 5 15.8333 5V15.8333C15.8333 16.2917 15.6701 16.684 15.3437 17.0104C15.0'
  + '174 17.3368 14.625 17.5 14.1667 17.5H5.83333ZM14.1667 5H5.83333V15.8333H14.1667V5ZM8.92708'
  + ' 13.9271C9.0868 13.7674 9.16667 13.5694 9.16667 13.3333V7.5C9.16667 7.26389 9.0868 7.06597'
  + ' 8.92708 6.90625C8.76736 6.74653 8.56944 6.66667 8.33333 6.66667C8.09722 6.66667 7.8993 6.'
  + '74653 7.73958 6.90625C7.57986 7.06597 7.5 7.26389 7.5 7.5V13.3333C7.5 13.5694 7.57986 13.7'
  + '674 7.73958 13.9271C7.8993 14.0868 8.09722 14.1667 8.33333 14.1667C8.56944 14.1667 8.76736'
  + ' 14.0868 8.92708 13.9271ZM12.2604 13.9271C12.4201 13.7674 12.5 13.5694 12.5 13.3333V7.5C12'
  + '.5 7.26389 12.4201 7.06597 12.2604 6.90625C12.1007 6.74653 11.9028 6.66667 11.6667 6.66667'
  + 'C11.4306 6.66667 11.2326 6.74653 11.0729 6.90625C10.9132 7.06597 10.8333 7.26389 10.8333 7'
  + '.5V13.3333C10.8333 13.5694 10.9132 13.7674 11.0729 13.9271C11.2326 14.0868 11.4306 14.1667'
  + ' 11.6667 14.1667C11.9028 14.1667 12.1007 14.0868 12.2604 13.9271Z'

const TrashCanIcon = ({ className, title, onClick }) => (
  <svg
    className={`tw:hover:text-[#ae0023]! ${className}`.trim()}
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    role="img"
    aria-label={title}
    onClick={onClick}
  >
    <path d={PATH} fill="currentColor" />
  </svg>
)

TrashCanIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

TrashCanIcon.defaultProps = {
  className: '',
  onClick: null,
  title: ''
}

export default TrashCanIcon
